module.exports = __webpack_public_path__ + "static/media/erkmenesen1.380757bb.jpg";